// extracted by mini-css-extract-plugin
export default {"headerForm":"CreateConsentTemplateForm_headerForm__JhdDm","submitButton":"CreateConsentTemplateForm_submitButton__C5U3+"};